webpackJsonp([114276838955818,60335399758886],{

/***/ 96:
/***/ (function(module, exports) {

	module.exports = {"data":{"allNavigationJson":{"edges":[{"node":{"to":"/projecten/architectuur","name":"PROJECTEN","key":"1","sub":true,"subItems":[{"to":"/projecten/architectuur","name":"ARCHITECTUUR","key":"1.0"},{"to":"/projecten/interieur","name":"INTERIEUR","key":"1.1"},{"to":"/projecten/in-opbouw","name":"IN OPBOUW","key":"1.2"}]}},{"node":{"to":"/contact/team","name":"CONTACT","key":"2","sub":true,"subItems":[{"to":"/contact/team","name":"TEAM","key":"2.0"},{"to":"/contact/info","name":"INFO","key":"2.1"}]}},{"node":{"to":"/nieuws/publicatie","name":"NIEUWS","key":"3","sub":true,"subItems":[{"to":"/nieuws/publicatie","name":"PUBLICATIE","key":"3.0"},{"to":"/nieuws/inspiratie","name":"INSPIRATIE","key":"3.1"}]}}]},"allProjectenJson":{"edges":[{"node":{"projecten":[{"id":"I01","type":"interieur","name":"STICHELBAUT","frontImage":"/images/uploads/stichelbaut_interieur_raste.jpg","wie":"STICHELBAUT","wat":"woning","waar":"Deinze","wanneer":"2020","afbeeldingen":[{"image":"/images/uploads/stichelbaut-17.jpg"},{"image":"/images/uploads/stichelbaut-18.jpg"},{"image":"/images/uploads/stichelbaut-19.jpg"},{"image":"/images/uploads/stichelbaut-20.jpg"},{"image":"/images/uploads/stichelbaut-21.jpg"},{"image":"/images/uploads/stichelbaut-22.jpg"},{"image":"/images/uploads/stichelbaut-23.jpg"},{"image":"/images/uploads/stichelbaut-23.jpg"},{"image":"/images/uploads/stichelbaut-27.jpg"}]},{"id":"I04","type":"interieur","name":"HUYGHE","frontImage":"/images/uploads/huyghe-raster-in.jpg","wie":"HUYGHE","wat":"Vrijstaande woning","waar":"Adegem","wanneer":"2021","afbeeldingen":[{"image":"/images/uploads/huyghe-8.jpg"},{"image":"/images/uploads/huyghe-9.jpg"},{"image":"/images/uploads/huyghe-10.jpg"},{"image":"/images/uploads/huyghe-11.jpg"},{"image":"/images/uploads/huyghe-12.jpg"},{"image":"/images/uploads/huyghe-13.jpg"}]},{"id":"I11","type":"interieur","name":"RODRIGUES","frontImage":"/images/uploads/de-fruyt-raster.jpg","wie":"RODRIGUES","wat":"Vrijstaande woning","waar":"Zomergem","wanneer":"2020","afbeeldingen":[{"image":"/images/uploads/de-fruyt-15-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-16-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-17-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-18-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-19-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-20-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-21-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-22-of-22-.jpg"}]},{"id":"I09","type":"interieur","name":"VONCK","frontImage":"/images/uploads/17-©nickcannaerts-homesweet.jpg","wie":"VONCK","wat":"Vrijstaande woning","waar":"Lovendegem","wanneer":"2019","afbeeldingen":[{"image":"/images/uploads/14-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/15-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/16-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/17-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/18-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/19-©nickcannaerts-homeswe.jpg"},{"image":"/images/uploads/20-©nickcannaerts-homeswe.jpg"},{"image":"/images/uploads/21-©nickcannaerts-homeswe.jpg"},{"image":"/images/uploads/22-©nickcannaerts-homeswe.jpg"}]},{"id":"I10","type":"interieur","name":"MALUMA","frontImage":"/images/uploads/maluma_interieur_raster.jpg","wie":"MALUMA","wat":"Verbouwing vrijstaande woning","waar":"Knokke-Heist","wanneer":"2020","afbeeldingen":[{"image":"/images/uploads/maluma_7.jpg"},{"image":"/images/uploads/maluma_8.jpg"},{"image":"/images/uploads/maluma_9.jpg"},{"image":"/images/uploads/maluma_10.jpg"}]},{"id":"I08","type":"interieur","name":"NEYT","frontImage":"/images/uploads/neyt_08.jpg","wie":"NEYT","wat":"halfopen woning","waar":"Wondelgem","wanneer":"2019","afbeeldingen":[{"image":"/images/uploads/neyt_08.jpg"},{"image":"/images/uploads/neyt_10.jpg"},{"image":"/images/uploads/neyt_06.jpg"},{"image":"/images/uploads/neyt_07.jpg"},{"image":"/images/uploads/neyt_09.jpg"},{"image":"/images/uploads/neyt_11.jpg"}]},{"id":"I07","type":"interieur","name":"VAN DE VELDE","frontImage":"/images/uploads/van-de-velde-interireur_raster.jpg","wie":null,"wat":"Uitvaartcentrum met woning","waar":"Zomergem","wanneer":"2018","afbeeldingen":[{"image":"/images/uploads/van-de-velde-16-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-15-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-17-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-18-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-19-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-20-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-21-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-22-of-22-.jpg"}]},{"id":"I02","type":"interieur","name":"MULTUM","frontImage":"/images/uploads/multum_interieur_raster.jpg","wie":"","wat":"Boekhoudkantoor","waar":"Wetteren","wanneer":"2016","afbeeldingen":[{"image":"/images/uploads/I02_FIDURO-03(finaal).jpg"},{"image":"/images/uploads/I02_FIDURO-04(finaal).jpg"},{"image":"/images/uploads/I02_FIDURO-05(finaal).jpg"},{"image":"/images/uploads/I02_FIDURO-06(finaal).jpg"},{"image":"/images/uploads/I02_FIDURO-08(finaal).jpg"},{"image":"/images/uploads/I02_FIDURO-09(finaal).jpg"},{"image":"/images/uploads/I02_FIDURO-10(finaal).jpg"},{"image":"/images/uploads/I02_FIDURO-11(finaal).jpg"},{"image":"/images/uploads/I02_FIDURO-12(finaal).jpg"}]},{"id":"I03","type":"interieur","name":"HULPIA","frontImage":"/images/uploads/hulpia_interieur_raster.jpg","wie":"Hulpia Freek & Desmet Hildegard","wat":"Halfopen eengezinswoning","waar":"Lovendegem","wanneer":"2011","afbeeldingen":[{"image":"/images/uploads/I03_HULPIA-03(finaal).jpg"},{"image":"/images/uploads/I03_HULPIA-04(finaal).jpg"},{"image":"/images/uploads/I03_HULPIA-05(finaal).jpg"},{"image":"/images/uploads/I03_HULPIA-06(finaal).jpg"},{"image":"/images/uploads/I03_HULPIA-07(finaal).jpg"},{"image":"/images/uploads/I03_HULPIA-08(finaal).jpg"},{"image":"/images/uploads/I03_HULPIA-09(finaal).jpg"},{"image":"/images/uploads/I03_HULPIA-10(finaal).jpg"},{"image":"/images/uploads/I03_HULPIA-11(finaal).jpg"}]},{"id":"I05","type":"interieur","name":"DEBAETS","frontImage":"/images/uploads/de-baedts_interieur_raster.jpg","wie":"","wat":"Vrijstaande eengezinswoning","waar":"Aalter","wanneer":"2015","afbeeldingen":[{"image":"/images/uploads/I05_DEBAETS-06(finaal).jpg"},{"image":"/images/uploads/I05_DEBAETS-07(finaal).jpg"}]},{"id":"I06","type":"interieur","name":"WITTE","frontImage":"/images/uploads/witte_interieur_raster.jpg","wie":"WITTE","wat":"Uitbreiding bestaande woning","waar":"Aalter","wanneer":"2016","afbeeldingen":[{"image":"/images/uploads/witte-06.jpg"},{"image":"/images/uploads/witte-07.jpg"},{"image":"/images/uploads/witte-08.jpg"}]},{"id":"P10","type":"architectuur","name":"HUYGHE","frontImage":"/images/uploads/huyghe-raster-ext.jpg","wie":"HUYGHE","wat":"Vrijstaande woning","waar":"Maldegem","wanneer":"2021","afbeeldingen":[{"image":"/images/uploads/huyghe-1.jpg"},{"image":"/images/uploads/huyghe-2.jpg"},{"image":"/images/uploads/huyghe-3.jpg"},{"image":"/images/uploads/huyghe-4.jpg"},{"image":"/images/uploads/huyghe-5.jpg"},{"image":"/images/uploads/huyghe-6.jpg"},{"image":"/images/uploads/huyghe-7.jpg"},{"image":"/images/uploads/huyghe-8.jpg"},{"image":"/images/uploads/huyghe-9.jpg"},{"image":"/images/uploads/huyghe-10.jpg"},{"image":"/images/uploads/huyghe-11.jpg"},{"image":"/images/uploads/huyghe-12.jpg"},{"image":"/images/uploads/huyghe-13.jpg"}]},{"id":"P19","type":"architectuur","name":"RODRIGUES","frontImage":"/images/uploads/de-fruyt-2-of-22-.jpg","wie":"","wat":"Vrijstaande woning","waar":"Zomergem","wanneer":"2020","afbeeldingen":[{"image":"/images/uploads/de-fruyt-1-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-2-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-3-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-4-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-5-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-6-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-7-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-8-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-9-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-10-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-11-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-12-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-13-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-13a-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-14-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-15-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-16-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-17-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-18-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-19-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-20-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-21-of-22-.jpg"},{"image":"/images/uploads/de-fruyt-22-of-22-.jpg"}]},{"id":"P23","type":"architectuur","name":"STICHELBAUT","frontImage":"/images/uploads/stiche-raster.jpg","wie":"STICHELBAUT","wat":"Vrijstaande woning","waar":"Deinze","wanneer":"2020","afbeeldingen":[{"image":"/images/uploads/stichelbaut-1.jpg"},{"image":"/images/uploads/stichelbaut-2.jpg"},{"image":"/images/uploads/stichelbaut-8.jpg"},{"image":"/images/uploads/stichelbaut-10.jpg"},{"image":"/images/uploads/stichelbaut-12.jpg"},{"image":"/images/uploads/stichelbaut-15.jpg"},{"image":"/images/uploads/stichelbaut-18.jpg"},{"image":"/images/uploads/stichelbaut-19.jpg"},{"image":"/images/uploads/stichelbaut-21.jpg"},{"image":"/images/uploads/stichelbaut-22.jpg"},{"image":"/images/uploads/stichelbaut-27.jpg"},{"image":"/images/uploads/stichelbaut-28.jpg"}]},{"id":"P18","type":"architectuur","name":"MALUMA","frontImage":"/images/uploads/maluma_raster.jpg","wie":"MALUMA","wat":"Verbouwing vrijstaande woning","waar":"Knokke-Heist","wanneer":"2020","afbeeldingen":[{"image":"/images/uploads/maluma_1.jpg"},{"image":"/images/uploads/maluma_2.jpg"},{"image":"/images/uploads/maluma_4.jpg"},{"image":"/images/uploads/maluma_5.jpg"},{"image":"/images/uploads/maluma_6.jpg"},{"image":"/images/uploads/maluma_7.jpg"},{"image":"/images/uploads/maluma_8.jpg"},{"image":"/images/uploads/maluma_9.jpg"},{"image":"/images/uploads/maluma_10.jpg"},{"image":"/images/uploads/maluma_11.jpg"}]},{"id":"P17","type":"architectuur","name":"VONCK","frontImage":"/images/uploads/vonck_raster.jpg","wie":"","wat":"Vrijstaande woning","waar":"Lovendegem","wanneer":"2019","afbeeldingen":[{"image":"/images/uploads/01-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/02-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/03-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/04-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/05-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/06-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/07-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/08-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/09-vonck_07.jpg"},{"image":"/images/uploads/10-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/11-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/12-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/13-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/14-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/15-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/16-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/17-©nickcannaerts-homesweet.jpg"},{"image":"/images/uploads/18-©nickcannaerts-homesweet.jpg"}]},{"id":"P15","type":"architectuur","name":"NEYT","frontImage":"/images/uploads/p15_neyt-raster.jpg","wie":"NEYT","wat":"halfopen woning","waar":"Wondelgem","wanneer":"2019","afbeeldingen":[{"image":"/images/uploads/neyt_01.jpg"},{"image":"/images/uploads/neyt_02.jpg"},{"image":"/images/uploads/neyt_03.jpg"},{"image":"/images/uploads/neyt_04.jpg"},{"image":"/images/uploads/neyt_05.jpg"},{"image":"/images/uploads/neyt_06.jpg"},{"image":"/images/uploads/neyt_07.jpg"},{"image":"/images/uploads/neyt_09.jpg"},{"image":"/images/uploads/neyt_08.jpg"},{"image":"/images/uploads/neyt_10.jpg"},{"image":"/images/uploads/neyt_11.jpg"}]},{"id":"P11","type":"architectuur","name":"VAN STEIRTEGEM","frontImage":"/images/uploads/van-steirtegem-raster.jpg","wie":"","wat":"Verbouwing Vrijstaande woning","waar":"Laarne","wanneer":"2019","afbeeldingen":[{"image":"/images/uploads/van-steirtegem-1.jpg"},{"image":"/images/uploads/van-steirtegem-2.jpg"},{"image":"/images/uploads/van-steirtegem-3.jpg"},{"image":"/images/uploads/van-steirtegem-4.jpg"},{"image":"/images/uploads/van-steirtegem-5.jpg"},{"image":"/images/uploads/van-steirtegem-6.jpg"},{"image":"/images/uploads/van-steirtegem-7.jpg"},{"image":"/images/uploads/van-steirtegem-8.jpg"},{"image":"/images/uploads/van-steirtegem-9.jpg"},{"image":"/images/uploads/van-steirtegem-10.jpg"},{"image":"/images/uploads/van-steirtegem-11.jpg"},{"image":"/images/uploads/van-steirtegem-12.jpg"}]},{"id":"P13","type":"architectuur","name":"VAN DE VELDE","frontImage":"/images/uploads/van-de-velde-12-of-22-.jpg","wie":"","wat":"Uitvaartcentrum met woning","waar":"Zomergem","wanneer":"2018","afbeeldingen":[{"image":"/images/uploads/van-de-velde-1-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-2-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-3-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-4-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-5-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-6-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-7-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-8-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-9-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-10-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-11-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-12-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-13-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-14-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-15-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-16-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-17-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-18-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-19-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-20-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-21-of-22-.jpg"},{"image":"/images/uploads/van-de-velde-22-of-22-.jpg"}]},{"id":"P25","type":"architectuur","name":"VAN DER VECKEN","frontImage":"/images/uploads/van-der-vecken-raster.jpg","wie":"VAN DER VECKEN","wat":"Vrijstaande woning","waar":"Destelbergen","wanneer":"2020","afbeeldingen":[{"image":"/images/uploads/van-der-vecken-10.jpg"},{"image":"/images/uploads/van-der-vecken-9.jpg"},{"image":"/images/uploads/van-der-vecken-8.jpg"},{"image":"/images/uploads/van-der-vecken-7.jpg"},{"image":"/images/uploads/van-der-vecken-6.jpg"},{"image":"/images/uploads/van-der-vecken-5.jpg"},{"image":"/images/uploads/van-der-vecken-4.jpg"},{"image":"/images/uploads/van-der-vecken-3.jpg"},{"image":"/images/uploads/van-der-vecken-2.jpg"},{"image":"/images/uploads/van-der-vecken-1.jpg"}]},{"id":"P21","type":"architectuur","name":"BUYSE","frontImage":"/images/uploads/buyse-01-raster.jpg","wie":"","wat":"4 appartementen","waar":"Blankenberge","wanneer":"2021","afbeeldingen":[{"image":"/images/uploads/buyse-01-1-of-1-.jpg"},{"image":"/images/uploads/buyse-03-1-of-1-.jpg"},{"image":"/images/uploads/buyse-02-1-of-1-.jpg"}]},{"id":"P04","type":"architectuur","name":"MERCKX","frontImage":"/images/uploads/merckx-raster.jpg","wie":"MERCKX","wat":"Vrijstaande woning","waar":"Evergem","wanneer":"2021","afbeeldingen":[{"image":"/images/uploads/merckx-0.jpg"},{"image":"/images/uploads/merckx-1.jpg"},{"image":"/images/uploads/merckx-2.jpg"},{"image":"/images/uploads/merckx-3.jpg"},{"image":"/images/uploads/merckx-4.jpg"},{"image":"/images/uploads/merckx-5.jpg"}]},{"id":"P01","type":"architectuur","name":"KIEKENS","frontImage":"/images/uploads/P01_KIEKENS---raster.jpg","wie":"","wat":"Vrijstaande eengezinswoning met atelier","waar":"Aalter","wanneer":"2015","afbeeldingen":[{"image":"/images/uploads/P01_KIEKENS-03(finaal).jpg"},{"image":"/images/uploads/P01_KIEKENS-01(finaal).jpg"},{"image":"/images/uploads/P01_KIEKENS-02(finaal).jpg"},{"image":"/images/uploads/P01_KIEKENS-04(finaal).jpg"},{"image":"/images/uploads/P01_KIEKENS-05(finaal).jpg"},{"image":"/images/uploads/P01_KIEKENS-06(finaal).jpg"},{"image":"/images/uploads/P01_KIEKENS-07(finaal).jpg"},{"image":"/images/uploads/P01_KIEKENS-08(finaal).jpg"},{"image":"/images/uploads/P01_KIEKENS-09(finaal).jpg"}]},{"id":"P05","type":"architectuur","name":"FIDURO","frontImage":"/images/uploads/P05_FIDURO---raster.jpg","wie":"","wat":"Boekhoudkantoor","waar":"Wetteren","wanneer":"2016","afbeeldingen":[{"image":"/images/uploads/P05_FIDURO-01(finaal).jpg"},{"image":"/images/uploads/multum-01.jpg"},{"image":"/images/uploads/multum-02.jpg"},{"image":"/images/uploads/multum-03.jpg"},{"image":"/images/uploads/multum-04.jpg"},{"image":"/images/uploads/mutlum-05.jpg"},{"image":"/images/uploads/P05_FIDURO-02(finaal).jpg"},{"image":"/images/uploads/P05_FIDURO-03(finaal).jpg"},{"image":"/images/uploads/P05_FIDURO-04(finaal).jpg"},{"image":"/images/uploads/P05_FIDURO-05(finaal).jpg"},{"image":"/images/uploads/P05_FIDURO-06(finaal).jpg"},{"image":"/images/uploads/P05_FIDURO-08(finaal).jpg"},{"image":"/images/uploads/P05_FIDURO-09(finaal).jpg"},{"image":"/images/uploads/P05_FIDURO-10(finaal).jpg"},{"image":"/images/uploads/P05_FIDURO-11(finaal).jpg"},{"image":"/images/uploads/P05_FIDURO-12(finaal).jpg"}]},{"id":"P02","type":"architectuur","name":"MAENHOUT","frontImage":"/images/uploads/P02_MAENHOUT---raster.jpg","wie":"","wat":"Vrijstaande eengezinswoning (BEN-woning)","waar":"Lovendegem","wanneer":"2016","afbeeldingen":[{"image":"/images/uploads/P02_MAENHOUT-01(finaal).jpg"},{"image":"/images/uploads/web_img_9712.jpg"},{"image":"/images/uploads/web_img_9347.jpg"},{"image":"/images/uploads/web_img_9348.jpg"},{"image":"/images/uploads/web_img_9596.jpg"},{"image":"/images/uploads/web_img_9545.jpg"},{"image":"/images/uploads/web_img_9572.jpg"},{"image":"/images/uploads/maenhout-01.jpg"}]},{"id":"P22","type":"architectuur","name":"LAMBRECHTS","frontImage":"/images/uploads/lambrechts-raster.jpg","wie":"LAMBRECHTS","wat":"verbouwing van eengezinswoning","waar":"Sint Kruis Brugge","wanneer":"2020","afbeeldingen":[{"image":"/images/uploads/lambrechts-1.jpg"},{"image":"/images/uploads/lambrechts-2.jpg"},{"image":"/images/uploads/lambrechts-3.jpg"},{"image":"/images/uploads/lambrechts-4.jpg"},{"image":"/images/uploads/lambrechts-5.jpg"},{"image":"/images/uploads/lambrechts-6.jpg"},{"image":"/images/uploads/lambrechts-7.jpg"},{"image":"/images/uploads/lambrechts-8.jpg"},{"image":"/images/uploads/lambrechts-9.jpg"},{"image":"/images/uploads/lambrechts-10.jpg"},{"image":"/images/uploads/lambrechts-11.jpg"},{"image":"/images/uploads/lambrechts-12.jpg"}]},{"id":"P14","type":"architectuur","name":"CASSIMAN","frontImage":"/images/uploads/cassiman_raster.jpg","wie":"","wat":"4 woningen","waar":"Sleidinge","wanneer":"2018","afbeeldingen":[{"image":"/images/uploads/cassiman_01.jpg"},{"image":"/images/uploads/cassiman_02.jpg"},{"image":"/images/uploads/cassiman_03.jpg"},{"image":"/images/uploads/cassiman_04.jpg"},{"image":"/images/uploads/cassiman_05.jpg"},{"image":"/images/uploads/cassiman_06.jpg"},{"image":"/images/uploads/cassiman_07.jpg"}]},{"id":"P03","type":"architectuur","name":"DEBAETS","frontImage":"/images/uploads/P03_DEBAETS---raster.jpg","wie":"","wat":"Vrijstaande eengezinswoning","waar":"Aalter","wanneer":"2015","afbeeldingen":[{"image":"/images/uploads/P03_DEBAETS-01(finaal).jpg"},{"image":"/images/uploads/P03_DEBAETS-02(finaal).jpg"},{"image":"/images/uploads/P03_DEBAETS-03(finaal).jpg"},{"image":"/images/uploads/P03_DEBAETS-04(finaal).jpg"},{"image":"/images/uploads/P03_DEBAETS-05(finaal).jpg"},{"image":"/images/uploads/P03_DEBAETS-06(finaal).jpg"},{"image":"/images/uploads/P03_DEBAETS-07(finaal).jpg"}]},{"id":"P16","type":"architectuur","name":"LÉJURÉ I","frontImage":"/images/uploads/lejure_raster.jpg","wie":"","wat":"5 woningen","waar":"Sleidinge","wanneer":"2019","afbeeldingen":[{"image":"/images/uploads/lejure_daasdonk_01.jpg"},{"image":"/images/uploads/lejure_daasdonk_02.jpg"},{"image":"/images/uploads/lejure_daasdonk_03.jpg"},{"image":"/images/uploads/lejure_daasdonk_04.jpg"},{"image":"/images/uploads/lejure_daasdonk_05.jpg"},{"image":"/images/uploads/lejure_daasdonk_07.jpg"}]},{"id":"P20","type":"architectuur","name":"LÉJURÉ II","frontImage":"/images/uploads/eeksken-raster.jpg","wie":"LÉJURÉ II","wat":"koppelwoning","waar":"Lievegem","wanneer":"2020","afbeeldingen":[{"image":"/images/uploads/eeksken-01.jpg"},{"image":"/images/uploads/eeksken-02.jpg"},{"image":"/images/uploads/eeksken-03.jpg"}]},{"id":"P24","type":"architectuur","name":"RDR","frontImage":"/images/uploads/rdr_raster.jpg","wie":"RDR","wat":"9 appartementen met een ondergrondse parking","waar":"Waarschoot","wanneer":"2021","afbeeldingen":[{"image":"/images/uploads/rdr_02.jpg"},{"image":"/images/uploads/rdr_01.jpg"}]},{"id":"P04","type":"architectuur","name":"NYS","frontImage":"/images/uploads/P04_NYS---raster.jpg","wie":"","wat":"Vrijstaande eengezinswoning","waar":"Beervelde","wanneer":"2015","afbeeldingen":[{"image":"/images/uploads/P04_NYS-01(finaal).jpg"},{"image":"/images/uploads/P04_NYS-02(finaal).jpg"},{"image":"/images/uploads/P04_NYS-03(finaal).jpg"},{"image":"/images/uploads/P04_NYS-04(finaal).jpg"},{"image":"/images/uploads/P04_NYS-05(finaal).jpg"}]},{"id":"P06","type":"architectuur","name":"HULPIA","frontImage":"/images/uploads/P06_HULPIA---raster.jpg","wie":"Hulpia Freek & Desmet Hildegard","wat":"Halfopen eengezinswoning","waar":"Lovendegem","wanneer":"2011","afbeeldingen":[{"image":"/images/uploads/P06_HULPIA-00(finaal).jpg"},{"image":"/images/uploads/P06_HULPIA-01(finaal).jpg"},{"image":"/images/uploads/P06_HULPIA-02(finaal).jpg"},{"image":"/images/uploads/P06_HULPIA-03(finaal).jpg"},{"image":"/images/uploads/P06_HULPIA-04(finaal).jpg"},{"image":"/images/uploads/P06_HULPIA-05(finaal).jpg"},{"image":"/images/uploads/P06_HULPIA-06(finaal).jpg"},{"image":"/images/uploads/P06_HULPIA-07(finaal).jpg"},{"image":"/images/uploads/P06_HULPIA-08(finaal).jpg"},{"image":"/images/uploads/P06_HULPIA-09(finaal).jpg"},{"image":"/images/uploads/P06_HULPIA-10(finaal).jpg"},{"image":"/images/uploads/P06_HULPIA-11(finaal).jpg"},{"image":"/images/uploads/P06_HULPIA-12(finaal).jpg"}]},{"id":"P07","type":"architectuur","name":"STEYAERT","frontImage":"/images/uploads/P07_STEYAERT---raster.jpg","wie":"","wat":"Nieuwbouw 13 appartementen","waar":"Merendree","wanneer":"2012","afbeeldingen":[{"image":"/images/uploads/P07_STEYAERT-01(finaal).jpg"},{"image":"/images/uploads/P07_STEYAERT-02(finaal).jpg"},{"image":"/images/uploads/P07_STEYAERT-03(finaal).jpg"},{"image":"/images/uploads/P07_STEYAERT-04(finaal).jpg"},{"image":"/images/uploads/P07_STEYAERT-05(finaal).jpg"},{"image":"/images/uploads/P07_STEYAERT-06(finaal).jpg"},{"image":"/images/uploads/P07_STEYAERT-07(finaal).jpg"}]},{"id":"P08","type":"architectuur","name":"FOU DU GOÛT","frontImage":"/images/uploads/P08_FOU-DU-GOUT---raster.jpg","wie":"","wat":"Uitbreiding restaurant","waar":"Lovendegem","wanneer":"2015","afbeeldingen":[{"image":"/images/uploads/P08_FOU_DE_GOUT-00(finaal).jpg"},{"image":"/images/uploads/P08_FOU_DE_GOUT-01(finaal).jpg"},{"image":"/images/uploads/P08_FOU_DE_GOUT-02(finaal).jpg"},{"image":"/images/uploads/P08_FOU_DE_GOUT-03(finaal).jpg"},{"image":"/images/uploads/P08_FOU_DE_GOUT-04(finaal).jpg"},{"image":"/images/uploads/P08_FOU_DE_GOUT-05(finaal).jpg"},{"image":"/images/uploads/P08_FOU_DE_GOUT-06(finaal).jpg"},{"image":"/images/uploads/P08_FOU_DE_GOUT-07(finaal).jpg"},{"image":"/images/uploads/P08_FOU_DE_GOUT-08(finaal).jpg"},{"image":"/images/uploads/P08_FOU_DE_GOUT-09(finaal).jpg"}]},{"id":"P09","type":"architectuur","name":"CONSTANDT","frontImage":"/images/uploads/P09_CONSTAND---raster.jpg","wie":"","wat":"Vrijstaande eengezinswoning met praktijk","waar":"Eeklo","wanneer":"2012","afbeeldingen":[{"image":"/images/uploads/P09_CONSTAND-01(finaal).jpg"},{"image":"/images/uploads/P09_CONSTAND-02(finaal).jpg"},{"image":"/images/uploads/P09_CONSTAND-03(finaal).jpg"},{"image":"/images/uploads/P09_CONSTAND-04(finaal).jpg"},{"image":"/images/uploads/P09_CONSTAND-05(finaal).jpg"},{"image":"/images/uploads/P09_CONSTAND-06(finaal).jpg"}]},{"id":"P12","type":"architectuur","name":"WITTE","frontImage":"/images/uploads/p12-witte-raster.jpg","wie":"WITTE","wat":"Uitbreiding bestaande woning","waar":"Aalter","wanneer":"2016","afbeeldingen":[{"image":"/images/uploads/witte-01.jpg"},{"image":"/images/uploads/witte-02.jpg"},{"image":"/images/uploads/witte-03.jpg"},{"image":"/images/uploads/witte-04.jpg"},{"image":"/images/uploads/witte-05.jpg"},{"image":"/images/uploads/witte-06.jpg"},{"image":"/images/uploads/witte-07.jpg"},{"image":"/images/uploads/witte-08.jpg"}]},{"id":"U01","type":"inOpbouw","name":"WENS","frontImage":"/images/uploads/wens_03raster.jpg","wie":"WENS","wat":"Vrijstaande woning","waar":"Westmalle","wanneer":"2022","afbeeldingen":[{"image":"/images/uploads/wens_01kopie.jpg"},{"image":"/images/uploads/wens_02kopie.jpg"},{"image":"/images/uploads/wens_03kopie.jpg"},{"image":"/images/uploads/wens_04kopie.jpg"}]},{"id":"U15","type":"inOpbouw","name":"STEYAERT","frontImage":"/images/uploads/steyaert_raster.jpg","wie":"STEYAERT","wat":"Eengezinswoning met loods","waar":"Nevele","wanneer":"Werf","afbeeldingen":[{"image":"/images/uploads/steyaert-05.jpg"},{"image":"/images/uploads/steyaert-06.jpg"},{"image":"/images/uploads/steyaert-04.jpg"},{"image":"/images/uploads/steyaert-01.jpg"},{"image":"/images/uploads/steyaert-02.jpg"},{"image":"/images/uploads/steyaert-03.jpg"}]},{"id":"U07","type":"inOpbouw","name":"NOVUM ESTATE Bibliothekstraat","frontImage":"/images/uploads/bibliotheek_raster.jpg","wie":"NOVUM ESTATE Bibliothekstraat","wat":"6 appartementen + commerciële ruimte","waar":"Evergem","wanneer":"2021","afbeeldingen":[{"image":"/images/uploads/bibliotheek-01.jpg"},{"image":"/images/uploads/bibliotheek-02.jpg"},{"image":"/images/uploads/bibliotheek-03.jpg"},{"image":"/images/uploads/bibliotheek-04.jpg"},{"image":"/images/uploads/bibliotheek-05.jpg"}]},{"id":"U13","type":"inOpbouw","name":"BASTIEN","frontImage":"/images/uploads/bastien-01.jpg","wie":"BASTIEN","wat":"Vrijstaande woning","waar":"Lembeke","wanneer":"klaar","afbeeldingen":[{"image":"/images/uploads/img_5024.jpg"},{"image":"/images/uploads/bastien-04.jpg"},{"image":"/images/uploads/bastien-02.jpg"},{"image":"/images/uploads/bastien-03.jpg"}]},{"id":"U16","type":"inOpbouw","name":"JANSSENS","frontImage":"/images/uploads/janssens_raster.jpg","wie":"JANSSENS","wat":"Vrijstaande woning","waar":"Lokeren","wanneer":"werf","afbeeldingen":[{"image":"/images/uploads/janssens-31-1-of-1-.jpg"},{"image":"/images/uploads/janssens-32-1-of-1-.jpg"},{"image":"/images/uploads/img_20211006_151842.jpg"},{"image":"/images/uploads/img_20211006_152248.jpg"},{"image":"/images/uploads/janssens_01.jpg"},{"image":"/images/uploads/janssens_02.jpg"},{"image":"/images/uploads/janssens_03.jpg"},{"image":"/images/uploads/janssens_04.jpg"}]},{"id":"U18","type":"inOpbouw","name":"MALDEX","frontImage":"/images/uploads/maldex_raster.jpg","wie":"MALDEX","wat":"Uitbreiding een kantoor","waar":"Evergem","wanneer":"werf","afbeeldingen":[{"image":"/images/uploads/img_20210907_142422.jpg"},{"image":"/images/uploads/img_20210907_143205.jpg"},{"image":"/images/uploads/maldex_01.jpg"},{"image":"/images/uploads/maldex_02.jpg"},{"image":"/images/uploads/maldex_03.jpg"}]},{"id":"U20","type":"inOpbouw","name":"MULTUM","frontImage":"/images/uploads/multum_raster.jpg","wie":"MULTUM","wat":"Uitbreiding van een boekhouderskantoor","waar":"Wetteren","wanneer":"Werf","afbeeldingen":[{"image":"/images/uploads/multum_01.jpg"},{"image":"/images/uploads/multum_03.jpg"},{"image":"/images/uploads/multum_04.jpg"},{"image":"/images/uploads/multum_05.jpg"},{"image":"/images/uploads/multum_07.jpg"},{"image":"/images/uploads/multum_08.jpg"},{"image":"/images/uploads/multum_10.jpg"},{"image":"/images/uploads/multum_11.jpg"}]},{"id":"U01","type":"inOpbouw","name":"VAN DE WALLE","frontImage":"/images/uploads/van-de-walle-raster.jpg","wie":"","wat":"Verbouwen van vrijstaand gebouw / onroerend erfgoed + nieuwe aanbouw","waar":"Waarschoot","wanneer":"Werf","afbeeldingen":[{"image":"/images/uploads/van-de-walle-01kopie.jpg"}]},{"id":"U02","type":"inOpbouw","name":"BOBELIJN","frontImage":"/images/uploads/bobelijn_raster.jpg","wie":"BOBELIJN","wat":"Vrijstaande woning","waar":"Assenede","wanneer":"Werf","afbeeldingen":[{"image":"/images/uploads/bobelijn_01.jpg"},{"image":"/images/uploads/bobelijn_02.jpg"}]},{"id":"U03","type":"inOpbouw","name":"CAYMAN","frontImage":"/images/uploads/cayman_raster.jpg","wie":"CAYMAN","wat":"halfopen woning","waar":"Sint-Amandsberg (Gent)","wanneer":"werf","afbeeldingen":[{"image":"/images/uploads/cayman-04.jpg"},{"image":"/images/uploads/cayman-03.jpg"},{"image":"/images/uploads/cayman-02.jpg"},{"image":"/images/uploads/cayman-01.jpg"}]},{"id":"U04","type":"inOpbouw","name":"VAN RENTERGHEM","frontImage":"/images/uploads/van-renterghem_raster.jpg","wie":"VAN RENTERGHEM","wat":"Vrijstaande woning","waar":"Evergem","wanneer":"Werf","afbeeldingen":[{"image":"/images/uploads/img20220712121401.jpg"},{"image":"/images/uploads/van-renterghem_01.jpg"},{"image":"/images/uploads/van-renterghem_02.jpg"},{"image":"/images/uploads/van-renterghem_03.jpg"}]},{"id":"U05","type":"inOpbouw","name":"NOVUM ESTATE Weststraat","frontImage":"/images/uploads/novum-estate-weststraat_ras.jpg","wie":"NOVUM ESTATE Weststraat","wat":"8 appartementen en een woning","waar":"Evergem","wanneer":"Werf","afbeeldingen":[{"image":"/images/uploads/weststraat_01.jpg"},{"image":"/images/uploads/weststraat_02.jpg"},{"image":"/images/uploads/weststraat_03.jpg"}]},{"id":"U06","type":"inOpbouw","name":"AKTUAL","frontImage":"/images/uploads/aktual_raster.jpg","wie":"AKTUAL","wat":"Vrijstaande woning","waar":"nieuwpoort","wanneer":"2021","afbeeldingen":[{"image":"/images/uploads/aktual_01.jpg"},{"image":"/images/uploads/aktual_02.jpg"},{"image":"/images/uploads/aktual_03.jpg"},{"image":"/images/uploads/aktual_04.jpg"}]}]}}]}},"layoutContext":{}}

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(200);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(96);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(283);
	var isArguments = __webpack_require__(282);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 282:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 283:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(531);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(281);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(512);
	
	var _HelmetConstants = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(8);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(290);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(546);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  border-bottom: 1px solid #000;\n'], ['\n  border-bottom: 1px solid #000;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 200px;\n'], ['\n  width: 200px;\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Hulpia = __webpack_require__(567);
	
	var _Hulpia2 = _interopRequireDefault(_Hulpia);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var HeaderStyled = _styledComponents2.default.section(_templateObject);
	
	var LogoImage = _styledComponents2.default.img(_templateObject2);
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    HeaderStyled,
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' },
	      _react2.default.createElement(LogoImage, { src: _Hulpia2.default, alt: 'logo' })
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n@font-face {\n  font-family: \'ISOCPEUR\';\n  src: url(', ');\n}\n* {\n  font-family: \'ISOCPEUR\';\n}\n'], ['\n@font-face {\n  font-family: \'ISOCPEUR\';\n  src: url(', ');\n}\n* {\n  font-family: \'ISOCPEUR\';\n}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: 0 auto;\n  max-width: 860px;\n  padding: 0px 1.0875rem 1.45rem;\n  padding-top: 0;\n'], ['\n  margin: 0 auto;\n  max-width: 860px;\n  padding: 0px 1.0875rem 1.45rem;\n  padding-top: 0;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding-top: 40px;\n  position: sticky;\n  background-color: #fff;\n  top: 0;\n  z-index: 3;\n'], ['\n  padding-top: 40px;\n  position: sticky;\n  background-color: #fff;\n  top: 0;\n  z-index: 3;\n']);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(511);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(196);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Navigation = __webpack_require__(21);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ISOCPEUR = __webpack_require__(304);
	
	var _ISOCPEUR2 = _interopRequireDefault(_ISOCPEUR);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	(0, _styledComponents.injectGlobal)(_templateObject, _ISOCPEUR2.default);
	
	var Wrapper = _styledComponents2.default.section(_templateObject2);
	
	var Sticky = _styledComponents2.default.div(_templateObject3);
	
	var TemplateWrapper = function (_Component) {
	  _inherits(TemplateWrapper, _Component);
	
	  function TemplateWrapper() {
	    _classCallCheck(this, TemplateWrapper);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TemplateWrapper.prototype.render = function render() {
	    var navItems = this.props.data.allNavigationJson.edges;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'Hulpia Architecten | architectuur & interieur',
	        meta: [{
	          name: 'description',
	          content: 'Hulpia Architecten | architectuur & interieur'
	        }, {
	          name: 'keywords',
	          content: 'Hulpia Architecten | architectuur & interieur'
	        }]
	      }),
	      _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Sticky,
	          null,
	          _react2.default.createElement(_Header2.default, null),
	          _react2.default.createElement(_Navigation2.default, { items: navItems })
	        ),
	        this.props.children(_extends({}, this.props))
	      )
	    );
	  };
	
	  return TemplateWrapper;
	}(_react.Component);
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = TemplateWrapper;

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ISOCPEUR.86e5ce86.ttf";

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-723426f9dc3645c1644f.js